import { classNames } from '../utils/class-names';
import styles from './spinner.component.module.css';

export interface SpinnerProps {
	/** Diameter. Defaults to `medium`. */
	size?: 'small' | 'medium' | 'large';
	/** Accessible label for the busy state. Defaults to "Loading". */
	label?: string;
	className?: string;
}

/** An indeterminate loading spinner. */
export function Spinner({ size = 'medium', label = 'Loading', className }: SpinnerProps) {
	return (
		<span
			className={classNames(styles.spinner, className)}
			data-size={size}
			role="status"
			aria-label={label}
		/>
	);
}
